import { Loadable } from 'components/common';
import { AIAgentCallChatProvider, useAIAgentCenterContext } from 'contexts/ai-agent-center';
import React, { useEffect, useRef } from 'react';
import { colorsBase } from 'themes';
import { CallSessionDto } from 'types';
import { useDivWidth } from 'utils/layout';
import AIAgentCallChat from './AIAgentCallChat';
import { onReceiveCallSessionAiProgressing } from 'services';

type Props = {
  callSession: CallSessionDto;
  isIntervention: boolean;
};
const AIAgentCallChatBox: React.FC<Props> = ({ callSession, isIntervention }) => {
  const ref = useRef<HTMLDivElement>(null);
  const chatBoxWidth = useDivWidth(ref);
  const { setCallSession } = useAIAgentCenterContext();

  useEffect(() => {
    const handleReceiveChat = (data: CallSessionDto) => {
      if (data.callSessionId === callSession?.callSessionId) {
        setCallSession(data);
      }
    };

    onReceiveCallSessionAiProgressing(handleReceiveChat);
  }, [callSession.callSessionId]);

  return (
    <div ref={ref}>
      {chatBoxWidth > 0 && (
        <Loadable>
          <AIAgentCallChatProvider
            key={`${callSession.callSessionId}-${callSession.callUuid}-${chatBoxWidth}`}
            isRead={false}
            endpointName={'call-chat-sessions'}
            callSession={callSession}
            variables={{
              systemMessText: colorsBase.mainTextColor
            }}
            isShowName={false}
            chatBoxWidth={chatBoxWidth * 0.7}
            setCallSession={setCallSession}
          >
            <AIAgentCallChat isIntervention={isIntervention} />
          </AIAgentCallChatProvider>
        </Loadable>
      )}
    </div>
  );
};
export default AIAgentCallChatBox;
